import { render, staticRenderFns } from "./DropHandler.vue?vue&type=template&id=9c04c4ca&scoped=true"
import script from "./DropHandler.vue?vue&type=script&lang=js"
export * from "./DropHandler.vue?vue&type=script&lang=js"
import style0 from "./DropHandler.vue?vue&type=style&index=0&id=9c04c4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c04c4ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
